import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
    selector: 'app-invalid-input-dialog',
    templateUrl: './invalid-input-dialog.html'
})
export class InvalidInputDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<InvalidInputDialogComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any) { }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/invalid-input-dialog/invalid-input-dialog.ts